<template>
<div>
    <!-- INPUT -->
    <section class="container my-3">
        <h4>Inputs</h4>
        <!-- Default -->
        <div class="ms-3 my-4">
            <h5 class="mb-4">Default</h5>
            <div class="center content-inputs mb-2">
                <vs-input
                    label="Name"
                    v-model="value"
                    placeholder="Evan You"
                />
            </div>
            <p class="text-dark mt-0 mb-2">Codigo de ejemplo para la implementación de un input básico.</p>
            <!-- CODIGO HTML -->
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-input label="Name" v-model="value" placeholder="Evan You" />
</script></code></pre>
            </div>
            <!-- <pre><textarea style="height:115px;" readonly>
            <vs-input
                label="Name"
                v-model="value"
                placeholder="Evan You"
            /></textarea></pre> -->
                <p class="text-dark mb-0 mt-4">Codigo de ejemplo para la implementación de un input básico</p>
                <!-- CODIGO HTML -->
                <div v-highlight><pre class="language-javascript p-0"><code><script type="text/plain" class="language-markup">
        export default {
            data:function(){
                return{
                    value: '',
                }
            }
        }
                </script></code></pre>
                            </div>
        </div>
        <!-- Tipos -->
        <div class="ms-3 my-4">
            <h5>Tipos</h5>
            <p class="text-dark mt-0 mb-4">Tipos de input disponibles</p>
            <div class="row">
                <div class="col-12 col-md-4">
                    <vs-input type="text" placeholder="Text" v-model="valueText" label="Text" />
                </div>
                <div class="col-12 col-md-4">
                    <vs-input type="password" placeholder="****" v-model="valuePassword" label="Password"/>
                </div>
                <div class="col-12 col-md-4">
                    <vs-input type="search" placeholder="Buscar" v-model="valueSearch" label="Search" />
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-4">
                    <vs-input type="number" placeholder="0" v-model="valueNumber" label="Number" />
                </div>
                <div class="col-12 col-md-4">
                    <vs-input type="time" v-model="valueTime" label="time" />
                </div>
                <div class="col-12 col-md-4">
                    <vs-input type="date" v-model="valueDate" label="Date" />
                </div>
                <!-- <div class="col-12 col-md-4">
                    <vs-input type="date" :min="valueDateMin" :max="valueDateMax" v-model="valueDate1" label="Date con limitantes" />
                </div> -->
            </div>


            <!-- CODIGO HTML -->
            <p class="text-dark mb-0">Codigo de ejemplo para la implementación de los tipos de input.</p>
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-input type="text" label="Name" v-model="value" placeholder="Evan You" />
</script></code></pre>
            </div>
            <p class="m-0 p-0">La propiedad <u>type</u> varia para hacer el input del tipo que se necesite en la ocasión. <br>
                <code>
                    text <br>
                    password <br>
                    search <br>
                    <!-- number <br> -->
                    time <br>
                    date
                </code>
            </p>

            <!-- <pre><textarea style="height:633px;" readonly>
            <div class="center content-inputs">
                <vs-input
                    type="text"
                    v-model="valueText"
                    label="Text"
                />
                    <vs-input
                    type="password"
                    v-model="valuePassword"
                    label="Password"
                />
                    <vs-input
                    type="search"
                    v-model="valueSearch"
                    label="Search"
                />
                    <vs-input
                    type="number"
                    v-model="valueNumber"
                    label="Number"
                />
                    <vs-input
                    type="time"
                    v-model="valueTime"
                    label="time"
                />
                <vs-input
                    type="date"
                    v-model="valueDate"
                    label="Date"
                />
            </div></textarea></pre> -->
            <!-- <p class="text-dark mt-4 mb-0"><font-awesome-icon icon="fa-brands fa-js" class="_js"></font-awesome-icon> <font-awesome-icon icon="fa-brands fa-vuejs" class=" _vue"></font-awesome-icon>Codigo de ejemplo para la implementación de los tipos de input.</p>

            <pre><textarea style="height:270px;" readonly>
            export default {
                data:function(){
                    return{
                        valueText: '',
                        valuePassword: '',
                        valueSearch: '',
                        valueNumber: '',
                        valueTime: '',
                        valueDate: '',
                    }
                }
            }
            </script></textarea></pre> -->
        </div>
        <!-- Estatus -->
        <!-- <div class="my-2 ms-3 my-4">
            <h5>Estatus</h5>
            <p class="text-dark my-0">Diferentes colores de input disponibles para indicar el estatus de la información agregada al input</p>
            <ul>
                <li><code>success</code> (Valor agregado correctamente)</li>
                <li><code>warn</code> (Advertencia con el valor agregado en el input)</li>
                <li><code>danger</code> (Valor del input no agregado y es necesario)</li>

            </ul>
            <div class="center content-inputs d-flex justify-content-around mt-4 mb-2" style="width: 90%">
                <vs-input
                    label="Success"
                    :state="bandera? 'success' : ''"
                />
                <vs-input
                    label="Warn"
                    :state="bandera? 'warn' : ''"
                />
                <vs-input
                    label="Danger"
                    :state="bandera? 'danger' : ''"
                />
            </div>
            <p class="text-dark my-0"><font-awesome-icon icon="fa-brands fa-vuejs _vue" class="_vue"></font-awesome-icon> Codigo de ejemplo para la implementación de los diferentes estatus en el input</p>
            
            <pre><textarea style="height:345px;" readonly>
            <div class="center content-inputs">
                <vs-input
                    label="Success"
                    placeholder="Success"
                    :state="bandera? 'success' : ''"
                />
                <vs-input
                    label="Warn"
                    placeholder="Warn"
                    :state="bandera? 'warn' : ''"
                />
                <vs-input
                    label="Danger"
                    placeholder="Danger"
                    :state="bandera? 'danger' : ''"
                />
            </div></textarea></pre>

            <p class="text-dark my-0"><font-awesome-icon icon="fa-brands fa-js" class="_js"></font-awesome-icon> <font-awesome-icon icon="fa-brands fa-vuejs" class=" _vue"></font-awesome-icon> Codigo de ejemplo para la implementación de los diferentes estatus en el input</p>
            
            <pre><textarea style="height:175px;" readonly>
            export default {
                data:function(){
                    return{
                        bandera: true,
                    }
                }
            }
            </script></textarea></pre>

        </div> -->
        <!-- Fecha -->
        <div class="ms-3 my-4">
            <h5 class="mb-4">Fecha</h5>
            <vs-input type="date" :min="valueDateMin" :max="valueDateMax" v-model="valueDateRange" label="Fecha con rangos" />
            <!-- CODIGO DE EJEMPLO -->
            <p class="text-dark mb-0">Codigo de ejemplo para la implementación de los rangos de fecha en el input date</p>
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-input type="date" :min="valueDateMin" :max="valueDateMax" v-model="valueDate" label="Fecha con rangos" />
</script></code></pre></div>
            <p class="text-dark mb-0 mt-3">Variables de ejemplo para agregar los limites en el input date</p>
            <div v-highlight><pre class="language-javascript"><code>export default {
    data:function(){
        return{
            valueDate: '2022-01-15',
            valueDateMin: '2022-01-01',
            valueDateMax: '2022-01-30',
        }
    }
}</code></pre>
            </div>
        </div>
        <!-- Propiedades -->
        <div class="ms-3 my-4">
            <!-- <div class="mb-3">
                <h5>Atributos <u>obligatorios</u> de vs-input</h5>
                <code>label="Name"</code> Texto que se mostrara en el label del input <br>
                <code>v-model="value""</code> Variable en donde se guardará el valor del input <br>
            </div> -->
            <!-- <div class="mb-5">
                <h5>Atributos <u>opcionales</u> de vs-input</h5>
                <code>placeholder="Ingrese un valor"</code> <br>
                <code>type="text"</code> El tipo de input por default es el de <span class="fst-italic">text</span> <br> -->
                <!-- <code>:state="bandera? 'success' : ''"</code> Se recomienda utilizar una bandera para controlar el estatus del valor de los inputs <br> -->
            <!-- </div>  -->
            <p class="text-dark my-0">Propiedades del componente input.</p> 
            <table class="table" style="font-size:.8rem;">
                <thead>
                    <tr>
                    <th scope="col">Propiedad</th>
                    <th scope="col">Obligatorio</th>
                    <th scope="col">Atributo</th>
                    <th scope="col">Descripción</th>
                    </tr>
                </thead>
                <tbody class="table-group-divider">
                    <tr v-for="(desc, index) in descripcion" :key="index">
                    <th scope="row"> <code>{{desc.propiedad}}</code> </th>
                    <td>{{desc.obligatorio}}</td>
                    <td>{{desc.tipo}}</td>
                    <td>{{desc.descripcion}} </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </section>
    <!-- TEXTAREA -->
    <section class="container my-3">
        <div class="ms-3 my-4">
            <h4>Textarea</h4>
            <label class="labelTextarea" for="TextareaName">Ingrese su comentario</label>
            <textarea class="form-control" placeholder="Ingrese su comentario..." id="TextareaName"></textarea>
            <p class="text-dark mb-0">Codigo de ejemplo para la implementación de textarea.</p>
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><label class="labelTextarea" for="TextareaName">Ingrese su comentario</label>
<textarea class="form-control" placeholder="Ingrese su comentario..." id="TextareaName"></textarea>
    </script></code></pre></div>

        </div>

    </section>
    <section class="container my-3">
        <h4>Moneda</h4>
            <!-- Campo Moneda -->
            <div class="ms-3 my-4">
                <h5>Campo moneda</h5>
                <p class="text-dark mt-0 mb-2">Input para el ingreso de montos.</p>
                <div class="row">
                    <div class="col-12 col-md-4 mb-3">
                        <money v-model="valueMoneda" v-bind="money"></money>
                    </div>
                </div>
                <!-- CODIGO HTML -->
                <p class="text-dark my-0">Código de ejemplo para la implementación del campo moneda.</p> 
                <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><money v-model="valueMoneda" v-bind="money"></money></script></code></pre>
                </div>
                
                <p class="text-dark my-0 mt-4">Código de ejemplo para la configuración del campo moneda.</p>
                <!-- CODIGO QUE SE MUESTRA --> 
                <div v-highlight>
    <pre class="language-javascript"><code>export default {
        data: function(){
            return{
                valueMoneda: 15000.50,
                money: {
                    decimal: '.', //Separador de decimales
                    thousands: ',', //Separador de miles
                    prefix: '$ ', //Simbolo de la moneda a utilizar
                    suffix: ' MXN', //Nomenclatura de la moneda
                    precision: 2, //Posiciones de decimales
                    masked: false //Salida del componente con máscara o no
                }
            }
        }
    }</code></pre>
                </div>
                <table class="table" style="font-size:.8rem;">
                    <thead>
                        <tr>
                        <th scope="col">Propiedad</th>
                        <th scope="col">Obligatorio</th>
                        <th scope="col">Atributo</th>
                        <th scope="col">Descripción</th>
                        </tr>
                    </thead>
                    <tbody class="table-group-divider">
                        <tr v-for="(desc, index) in descripcionMoneda" :key="index">
                        <th scope="row"> <code>{{desc.propiedad}}</code> </th>
                        <td>{{desc.obligatorio}}</td>
                        <td>{{desc.tipo}}</td>
                        <td>{{desc.descripcion}} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Filtro Moneda -->
            <div class="ms-3 my-4">
                <h5>Filtro moneda</h5>
                <p class="text-dark mt-0 mb-2">Método que agrega visualmente el formato moneda a datos numéricos.</p>
                <div class="ps-4">
                    <p class="body-3 mb-0">Monto con dos decimales: {{valueMoneda2 | moneda(2)}}</p>
                    <p class="body-3">Monto con dos decimales: {{valueMoneda3 | moneda(3)}}</p>
                </div>


                 <!-- CODIGO HTML -->
                <p class="text-dark mb-0 mt-3">Para usar el filtro moneda hay que poner una barra vertical y el nombre del método (moneda). El método recibe el numero de decimales que se mostraran  </p> 
                <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><p class="body-3">Monto con dos decimales: { {valueMoneda | moneda(2)}}</p>
<p class="body-3">Monto con dos decimales: { {valueMoneda2 | moneda(3)}}</p></script></code></pre></div>

                <p class="text-dark my-0 mt-4">Código de ejemplo para la implementación del filtro moneda.</p>
                <!-- CODIGO QUE SE MUESTRA --> 
                <div v-highlight>
    <pre class="language-javascript"><code>export default {
        data: function(){
            return{
                valueMoneda: 255000.795,
                valueMoneda2: 1250.895
            }
        }
    }</code></pre>
                </div>


            </div>
    </section>
</div>
</template>
<script>
export default {
    created(){
        window.scrollTo(0, 0);
    },
    data:function(){
        return{
            value: '',
            valueText: '',
            valuePassword: '',
            valueSearch: '',
            valueNumber: '',
            

            valueTime: '',
            valueDate: '',
            bandera: true,

            valueDateRange:'2022-01-15',
            valueDateMin: '2022-01-01',
            valueDateMax: '2022-01-31',

            


            descripcion: [
                {'propiedad': 'label', 'obligatorio': 'Si', 'tipo': 'String', 'descripcion': 'Texto que se mostrara en el label del input.'},
                {'propiedad': 'v-model', 'obligatorio': 'Si', 'tipo': 'Variable', 'descripcion': 'Se le indica la variable en donde se guardará el valor del input'},
                {'propiedad': 'placeholder', 'obligatorio': 'No', 'tipo': 'String', 'descripcion': 'Texto provisional que se mostrara en el input'},
                {'propiedad': 'type', 'obligatorio': 'No', 'tipo': 'String', 'descripcion': 'El tipo de input por default es el de text'},
                {'propiedad': ':min', 'obligatorio': 'No', 'tipo': 'Variable', 'descripcion': 'Agrega un rango minimo de fecha disponible al input de tipo date'},
                {'propiedad': ':max', 'obligatorio': 'No', 'tipo': 'Variable', 'descripcion': 'Agrega un rango máximo de fecha disponible al input de tipo date'},
            ],



            htmlvalue: ' <vs-input ',
            htmlvalue2: 'label="Name" v-model="value" placeholder="Evan You" />',

            htmlvalue3: '<label class="labelTextarea" for="TextareaName">Ingrese su comentario</label>',
            htmlvalue4: '<textarea class="form-control" placeholder="Ingrese su comentario..." id="TextareaName"></textarea>',

            valueMoneda: 15000.50,
            money: {
                decimal: '.', //Separador de decimales
                thousands: ',', //Separador de miles
                prefix: '$ ',  //Simbolo de la moneda a utilizar
                suffix: ' MXN', //Nomenclatura de la moneda
                precision: 2, //Posiciones de decimales
                masked: false //Salida del componente debe incluir máscara o no
            },
            descripcionMoneda: [
                {'propiedad': 'v-model', 'obligatorio': 'Si', 'tipo': 'Variable', 'descripcion': 'Se le indica la variable en donde se guarda el dato que se ingrese en el campo.'},
                {'propiedad': 'v-bind', 'obligatorio': 'Si', 'tipo': 'Objeto', 'descripcion': 'Configuración de la moneda.'},
            ],
            valueMoneda2: 255000.795,
            valueMoneda3: 1250.895

            
        }
    }
}
</script>
